const __WEBPACK_NAMESPACE_OBJECT__ = require("just-handlebars-helpers");;